// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ce98a8c7","453":"c2ed5747","796":"9134f740"}[chunkId] + ".chunk.js";
};